import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  template: `
    <div class="confirmation-dialog">
      <h2 mat-dialog-title>{{ data.title }}</h2>
      <div mat-dialog-content>
        <p>{{ data.message }}</p>
      </div>
      <div mat-dialog-actions align="end">
        <button mat-button (click)="onNoClick()">Annuler</button>
        <button mat-button color="warn" (click)="onYesClick()">Confirmer</button>
      </div>
    </div>
  `,
  styles: [`
    .confirmation-dialog {
      padding: 20px;
      max-width: 400px;
    }
    h2 {
      margin: 0;
      font-size: 1.5em;
      color: #333;
    }
    p {
      margin: 20px 0;
      color: #666;
      line-height: 1.5;
    }
    [mat-dialog-actions] {
      margin-top: 20px;
    }
    button {
      min-width: 100px;
      margin-left: 8px;
    }
  `]
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string;
      message: string;
    }
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
